const BUTTONS = [
  { command: "bold", label: "G", title: "Gras", className: "is-bold" },
  { command: "italic", label: "I", title: "Italique", className: "is-italic" },
  { command: "underline", label: "S", title: "Souligné", className: "is-underline" },
  { command: "insertUnorderedList", label: "Liste", title: "Liste à puces" },
  { command: "createLink", label: "Lien", title: "Insérer un lien" },
]

const sourceToHtml = (value) => {
  const text = (value || "").toString()
  if (!text.trim()) return ""
  if (/<(?:br|p|div|ul|ol|li|strong|em|b|i|u|a|span)\b/i.test(text)) {
    return text
  }
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\n/g, "<br>")
}

const normalizeHtml = (html) => {
  const wrapper = document.createElement("div")
  wrapper.innerHTML = html || ""

  wrapper.querySelectorAll("b").forEach((node) => {
    const strong = document.createElement("strong")
    strong.innerHTML = node.innerHTML
    node.replaceWith(strong)
  })
  wrapper.querySelectorAll("i").forEach((node) => {
    const em = document.createElement("em")
    em.innerHTML = node.innerHTML
    node.replaceWith(em)
  })
  wrapper.querySelectorAll("div").forEach((node) => {
    if (node.parentElement !== wrapper) return
    const next = document.createElement("p")
    next.innerHTML = node.innerHTML
    node.replaceWith(next)
  })

  let output = wrapper.innerHTML
    .replace(/<div><br><\/div>/gi, "<br>")
    .replace(/<\/div>\s*<div>/gi, "<br>")
    .replace(/<\/?div>/gi, "")
    .trim()

  if (output === "<br>" || output === "<br/>") output = ""
  return output
}

const selectionInside = (editor) => {
  const selection = window.getSelection()
  if (!selection || selection.rangeCount === 0) return false
  const node = selection.anchorNode
  return editor.contains(node.nodeType === Node.TEXT_NODE ? node.parentElement : node)
}

const inList = (editor) => {
  const selection = window.getSelection()
  if (!selection || selection.rangeCount === 0) return false
  let node = selection.anchorNode
  if (node?.nodeType === Node.TEXT_NODE) node = node.parentElement
  return Boolean(node?.closest?.("ul, ol") && editor.contains(node))
}

const syncFromEditor = (textarea, editor) => {
  textarea.value = normalizeHtml(editor.innerHTML)
  textarea.dispatchEvent(new Event("input", { bubbles: true }))
}

const runCommand = (command, editor, textarea) => {
  editor.focus()
  if (command === "createLink") {
    const selection = window.getSelection()
    if (!selection || selection.isCollapsed) {
      window.alert("Sélectionnez d’abord le texte à transformer en lien.")
      return
    }
    const url = window.prompt("Adresse du lien (https://…)", "https://")
    if (!url) return
    document.execCommand("createLink", false, url.trim())
  } else {
    document.execCommand(command, false, null)
  }
  syncFromEditor(textarea, editor)
}

const buildToolbar = (editor, textarea) => {
  const toolbar = document.createElement("div")
  toolbar.className = "backoffice-rich-text__toolbar"
  toolbar.setAttribute("role", "toolbar")
  toolbar.setAttribute("aria-label", "Mise en forme")

  BUTTONS.forEach((button) => {
    const el = document.createElement("button")
    el.type = "button"
    el.className = `backoffice-rich-text__btn${button.className ? ` ${button.className}` : ""}`
    el.title = button.title
    el.setAttribute("aria-label", button.title)
    el.textContent = button.label
    el.addEventListener("mousedown", (event) => event.preventDefault())
    el.addEventListener("click", (event) => {
      event.preventDefault()
      runCommand(button.command, editor, textarea)
    })
    toolbar.appendChild(el)
  })

  return toolbar
}

const enhanceTextarea = (textarea) => {
  if (!(textarea instanceof HTMLTextAreaElement)) return
  if (textarea.dataset.richTextReady === "true") return

  const root = document.createElement("div")
  root.className = "backoffice-rich-text"
  root.dataset.richTextRoot = "true"

  const editor = document.createElement("div")
  editor.className = "backoffice-rich-text__editor"
  editor.contentEditable = "true"
  editor.spellcheck = true
  editor.setAttribute("role", "textbox")
  editor.setAttribute("aria-multiline", "true")
  if (textarea.hasAttribute("data-rich-text-compact")) {
    root.classList.add("backoffice-rich-text--compact")
  }
  editor.innerHTML = sourceToHtml(textarea.value)

  const toolbar = buildToolbar(editor, textarea)

  textarea.classList.add("backoffice-rich-text__source")
  textarea.dataset.richTextReady = "true"
  textarea.setAttribute("aria-hidden", "true")
  textarea.tabIndex = -1

  textarea.parentNode.insertBefore(root, textarea)
  root.appendChild(toolbar)
  root.appendChild(editor)
  root.appendChild(textarea)

  editor.addEventListener("input", () => syncFromEditor(textarea, editor))
  editor.addEventListener("blur", () => syncFromEditor(textarea, editor))

  editor.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" || event.shiftKey) return
    if (inList(editor)) return
    event.preventDefault()
    document.execCommand("insertLineBreak")
    syncFromEditor(textarea, editor)
  })

  editor.addEventListener("paste", (event) => {
    event.preventDefault()
    const text = event.clipboardData?.getData("text/plain") || ""
    document.execCommand("insertText", false, text)
    syncFromEditor(textarea, editor)
  })

  const form = textarea.closest("form")
  if (form && form.dataset.richTextSyncBound !== "true") {
    form.dataset.richTextSyncBound = "true"
    form.addEventListener(
      "submit",
      () => {
        form.querySelectorAll("[data-rich-text-root] .backoffice-rich-text__editor").forEach((ed) => {
          const source = ed.parentElement?.querySelector("textarea")
          if (source) syncFromEditor(source, ed)
        })
      },
      true
    )
  }

  // Keep selection commands working when clicking toolbar while editor had focus
  editor.addEventListener("mouseup", () => {
    if (!selectionInside(editor)) return
  })
}

export const initBackofficeRichText = (root = document) => {
  const scope = root instanceof Element || root instanceof Document ? root : document
  scope.querySelectorAll("textarea[data-rich-text]").forEach(enhanceTextarea)
}
